import React from 'react';
import {
  ResponsiveRatingLineChartSwitch,
  ResponsiveRatingLineChartSwitchProps,
} from './ResponsiveRatingLineChart';

export const CHART_CONTROL_TYPES = {
  RATING_SCALE_GROUP_ANSWERS: 'RATING_SCALE_GROUP_ANSWERS',
} as const;

interface CustomControlLegendProps {
  type: keyof typeof CHART_CONTROL_TYPES;
  controlProps: ResponsiveRatingLineChartSwitchProps;
}
export const CustomControlLegend = ({
  type,
  controlProps,
}: CustomControlLegendProps) => {
  if (type === CHART_CONTROL_TYPES.RATING_SCALE_GROUP_ANSWERS) {
    return (
      <ResponsiveRatingLineChartSwitch
        isChecked={controlProps.isChecked}
        onChange={controlProps.onChange}
        answersCount={controlProps.answersCount}
      />
    );
  }
  return null;
};
